import React from 'react';
import { PictoProps } from './index';

export const Bus = (props: PictoProps) => (
  <svg
    width={props.width || '16'}
    height={props.height || '20'}
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Icon bus"
      d="M11.9641 0H4.05931C1.86884 0 0.106934 1.7619 0.106934 3.95238V15.8095C0.106934 16.5476 0.702172 17.119 1.41646 17.119H2.0117C2.0117 17.1667 1.98789 17.1905 1.98789 17.2381V18.7619C1.98789 19.4286 2.53551 19.9762 3.20217 19.9762C3.86884 19.9762 4.41646 19.4286 4.41646 18.7619V17.2619C4.41646 17.2143 4.41646 17.1667 4.39265 17.1429H11.7736C11.7736 17.1905 11.7498 17.2143 11.7498 17.2619V18.7857C11.7498 19.4524 12.2974 20 12.9641 20C13.6307 20 14.1784 19.4524 14.1784 18.7857V17.2619C14.1784 17.2143 14.1784 17.1667 14.1546 17.1429H14.5831C15.3212 17.1429 15.8926 16.5476 15.8926 15.8333V3.95238C15.9165 1.7619 14.1546 0 11.9641 0ZM5.36884 1.30952H10.6307V2.61905H5.36884V1.30952ZM1.41646 14.5C1.41646 13.7619 2.0117 13.1905 2.72598 13.1905C3.44027 13.1905 4.03551 13.7857 4.03551 14.5C4.03551 15.2143 3.44027 15.8095 2.72598 15.8095C2.0117 15.8095 1.41646 15.2143 1.41646 14.5ZM13.2736 15.8095C12.5355 15.8095 11.9641 15.2143 11.9641 14.5C11.9641 13.7857 12.5593 13.1905 13.2736 13.1905C13.9879 13.1905 14.5831 13.7857 14.5831 14.5C14.6069 15.2143 14.0117 15.8095 13.2736 15.8095ZM14.6069 11.8571H1.41646V3.95238H14.5831V11.8571H14.6069Z"
      fill="white"
    />
  </svg>
);
